import { useCallback } from "react";
import { useHistory } from "react-router";
import styled from "styled-components";

// Components
import { Heading1, Paragraph } from "../components/typography";

// Containers
import ForgotPasswordForm from "../containers/forms/forgotPassword/ForgotPassword.form";

// Styles
import { media } from "../styles/media";

// On phones the subtitle wrapped across the full width and (via Paragraph's
// word-break: break-all) stranded a lone "k" on line 2. Center it and break it
// into two clean lines at a word boundary.
const Subtitle = styled(Paragraph)`
  margin: 0 0 40px 0;
  color: #8e8e8e;
  font-size: 14px;

  ${media.maxMobile`
    text-align: center;
    word-break: normal;
  `}
`;

const Break = styled.span`
  ${media.maxMobile`
    display: block;
  `}
`;

const ForgotPassword = () => {
  const history = useHistory();

  const handleSuccess = useCallback(() => {
    history.push("/");
  }, [history]);

  return (
    <>
      <Heading1 style={{ margin: "40px 0 8px 0", fontSize: 32 }}>
        Forgot Password
      </Heading1>
      <Subtitle>
        Enter your email to receive{" "}
        <Break>a password reset link.</Break>
      </Subtitle>
      <ForgotPasswordForm onSuccess={handleSuccess} />
    </>
  );
};

export default ForgotPassword;
